/* star.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
            <path class="foreground-gl" d="M10.37.37l2.48,6.4a.28.28,0,0,0,.24.18l6.58.5a.28.28,0,0,1,.16.49l-5.06,4.48a.28.28,0,0,0-.09.28l1.58,6.74a.28.28,0,0,1-.42.3L10.26,16.1a.28.28,0,0,0-.3,0L4.38,19.75a.28.28,0,0,1-.42-.3l1.58-6.74a.28.28,0,0,0-.09-.28L.39,7.95a.28.28,0,0,1,.16-.49L7.13,7a.28.28,0,0,0,.24-.18L9.85.37A.28.28,0,0,1,10.37.37Z" transform="translate(-0.29 -0.19)"/>
        </svg>
    `
};
